import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'

import { LoyaltyRewardsEarned } from './LoyaltyContent/LoyaltyRewardsEarned/LoyaltyRewardsEarned'
import { LoyaltyWelcome } from './LoyaltyContent/LoyaltyWelcome/LoyaltyWelcome'
import { LoyaltyContent } from './LoyaltyContent/LoyaltyContent'

import './LoyaltyConfirmation.css'
import { useAuth } from '../AuthProvider/AuthProvider'
import { useQuery } from 'react-apollo'
import { GET_COMPLETED_ORDER_LOYALTY_CONFIRMATION } from './LoyaltyConfirmation.graphql'
import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'

export const LoyaltyConfirmation = ({ orderGuid }) => {
  const { restaurantGuid } = useRestaurant()
  const { user, authenticated } = useAuth()
  const [loyaltyActionTaken, setLoyaltyActionTaken] = useState(false)

  const actionTakenCallback = useCallback(() => {
    setLoyaltyActionTaken(true)
  }, [])

  const { loading, error, data } = useQuery(GET_COMPLETED_ORDER_LOYALTY_CONFIRMATION, {
    variables: {
      input: {
        orderGuid,
        restaurantGuid
      }
    }
  })

  if (loading || error) return null

  const { completedOrder: { hasLoyaltyAttached, customerV2 } } = data

  const orderAndCMEmailsMatch = Boolean(customerV2 && user && customerV2.email === user.email)

  const showElement = orderAndCMEmailsMatch || !authenticated

  return showElement && (
    <React.Fragment>
      {loyaltyActionTaken
        ? hasLoyaltyAttached ? <LoyaltyRewardsEarned /> : <LoyaltyWelcome orderGuid={orderGuid} />
        : (
          <LoyaltyContent
            actionTakenCallback={actionTakenCallback}
            orderGuid={orderGuid}
          />
        )
      }
    </React.Fragment>
  )
}

LoyaltyConfirmation.propTypes = {
  orderGuid: PropTypes.string.isRequired
}
